/**
 * Fixes pasted media links the renderer package (@keepoinc/site-page-react-component) can't embed
 * yet, so the saved link works both in the preview and on the published Keepo.
 *
 * Spotify's "Share" links carry a language segment and tracking params
 * (open.spotify.com/intl-pt/track/ID?si=...): the package keeps the segment in the embed URL,
 * which then 404s. An already-embedded link (open.spotify.com/embed/...) would be embedded twice.
 */
export const normalizeMediaLink = (link?: string) => {
  const trimmed = link?.trim();
  if (!trimmed || !/open\.spotify\.com\//i.test(trimmed)) {
    return trimmed;
  }
  return trimmed
    .replace(/open\.spotify\.com\/(embed\/)?intl-[a-z]{2}(-[a-z]{2})?\//i, "open.spotify.com/")
    .replace(/open\.spotify\.com\/embed\//i, "open.spotify.com/")
    .replace(/[?#].*$/, "");
};

// Short links only resolve through a server-side redirect, which the browser can't follow
const SHORT_LINK_HOSTS: { pattern: RegExp; provider: string }[] = [
  { pattern: /\/\/(spotify\.link|spotify\.app\.link)\//i, provider: "Spotify" },
  { pattern: /\/\/(link\.deezer\.com|deezer\.page\.link)\//i, provider: "Deezer" },
];

/** The provider of a short share link (e.g. spotify.link/...), which can't be embedded. */
export const shortLinkProvider = (link?: string) =>
  link ? SHORT_LINK_HOSTS.find(({ pattern }) => pattern.test(link))?.provider : undefined;
